import { httpRequest } from '../../shared/lib/utils/httpClient';

export interface SignIn {
  username: string;
  password: string;
  userIp: string;
}
export interface SignInType {
  username: string;
  password: string;
}
export interface ForgotPasswordType {
  username: string;
  email: string;
}
export interface OtpType {
  otp: string;
}
export interface QrcodeType {
  userId: string | null;
  secretOTP: string;
  userIp: string | null;
}
export interface ResetPasswordType {
  token: string | null;
  newPassword: string;
}
export interface ResetPasswordProps {
  newPassword: string;
  confirmPassword: string;
}
export interface ChangePasswordType {
  username: string | null;
  oldPassword: string;
  newPassword: string;
}
export interface ChangePasswordProps {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}
export interface SignInResponse {
  token: string;
  userId: number;
  username: string;
  status: string;
  message: string;
  is2fa: boolean;
  qrCode: string;
  mfaUserId: number;
}
export interface QtpResponse {
  token: string;
  userId: number;
  username: string;
  status: string;
  message: string;
}
export interface SuccessResponse {
  code: number;
  message: string;
  status: string;
}

export interface UserDetails {
  userId: number;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  status: string;
}

export const Login = async (user: SignIn): Promise<SignInResponse> => {
  const response = await httpRequest<SignInResponse>({
    url: '/provider/login',
    method: 'POST',
    data: user,
  });
  return response;
};

export const forgotPassword = async (
  user: ForgotPasswordType
): Promise<SignInResponse> => {
  const response = await httpRequest<SignInResponse>({
    url: `/provider/forgot-password?username=${user.username}&email=${user.email}`,
    method: 'POST',
  });
  return response;
};
export const Qrotp = async (user: QrcodeType): Promise<QtpResponse> => {
  const response = await httpRequest<QtpResponse>({
    url: `/provider/validate-otp?userId=${user.userId}&secretOTP=${Number(user.secretOTP)}&ipAddress=''`,
    method: 'POST',
  });
  return response;
};
export const ResetPassword = async (
  user: ResetPasswordType
): Promise<SuccessResponse> => {
  const response = await httpRequest<SuccessResponse>({
    url: `/provider/reset-password?token=${user.token}&newPassword=${user.newPassword}`,
    method: 'POST',
  });
  return response;
};
export const ChangePassword = async (
  user: ChangePasswordType
): Promise<SuccessResponse> => {
  const response = await httpRequest<SuccessResponse>({
    url: `/provider/change-password`,
    method: 'POST',
    data: user,
  });
  return response;
};

export const getUserDetails = async (email: string): Promise<UserDetails> => {
  const response = await httpRequest<UserDetails>({
    url: `/clinical/user/details?emailId=${email}`,
    method: 'GET',
  });
  return response;
};
